import { DeactivationReason } from 'tools/bff/generated/user/user_administration_pb';

// Human labels for every structured reason except the UNSPECIFIED placeholder. Order defines the
// order they appear in the reason select. Shared by the single-user DeactivateUserModal and the
// bulk /users/bulk route so the two reason lists can never drift.
export const REASON_OPTIONS: ReadonlyArray<{ value: DeactivationReason; label: string }> = [
  { value: DeactivationReason.BOT, label: 'Bot' },
  { value: DeactivationReason.USER_REQUEST, label: 'User request' },
  { value: DeactivationReason.SHARED_CREDIT_CARD, label: 'Shared credit card' },
  { value: DeactivationReason.IP_SWEEP, label: 'IP sweep' },
  {
    value: DeactivationReason.PREVIOUSLY_DEACTIVATED_CREDIT_CARD,
    label: 'Previously deactivated credit card',
  },
  { value: DeactivationReason.RATE_LIMIT, label: 'Rate limit' },
  { value: DeactivationReason.MACHINE_LEARNING_MODEL, label: 'Machine learning model' },
  { value: DeactivationReason.MANUAL_PARTNER_FLAG, label: 'Manual partner flag' },
  { value: DeactivationReason.UNKNOWN, label: 'Unknown' },
  { value: DeactivationReason.OTHER, label: 'Other' },
];

const LABEL_BY_VALUE: ReadonlyMap<DeactivationReason, string> = new Map(
  REASON_OPTIONS.map(({ value, label }) => [value, label])
);

// Falls back to 'Unknown' for the UNSPECIFIED placeholder / any unmapped value.
export const deactivationReasonLabel = (value: DeactivationReason): string =>
  LABEL_BY_VALUE.get(value) ?? 'Unknown';
